const fetchDefaults = require("fetch-defaults")

export const createAuthenticatedClient = (reportsBaseUrl, authToken) => {
    const client = fetchDefaults(fetch, reportsBaseUrl, {
        headers: {
            Authorization: "AuthToken token=" + authToken,
        },
    });
    return client;
}
